import React from "react";
import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import { Trans } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import AppBar from "../../Components/AppBar";
import { usePortal } from "../../../../Providers/PortalProvider";
import Link from "@material-ui/core/Link";

const useStyles = makeStyles({
  portalAddress: {
    listStyle: "none",
    margin: "40px 0 20px 0",
    padding: 0,
  },
});

export default () => {
  const classes = useStyles();
  const portal = usePortal();
  const { contactInfo } = portal;

  console.log("Portal", portal);

  return (
    <MobilePage>
      <AppBar />
      <PageHeader>
        <Trans>Contact us</Trans>
      </PageHeader>

      <Container>
        <ul className={classes.portalAddress}>
          <li>{portal.name}</li>
          <li>{contactInfo.address}</li>
          <li>
            {contactInfo.postalCode} {contactInfo.city}
          </li>
          <li>{contactInfo.state}</li>
        </ul>
        <div>
          <Trans>Email address:</Trans>{" "}
          <Link href={"mailto:" + contactInfo.email}>{contactInfo.email}</Link>
        </div>
        <div>
          <Trans>Phone number:</Trans> {contactInfo.phone}
        </div>
      </Container>
    </MobilePage>
  );
};
